import { createSlice } from '@reduxjs/toolkit';
import { salesPitchInitialState } from './state';
import { salesPitchReducers } from './reducer';
import { SalesPitchExtraReducers, SalesPitchThunks } from './thunk';
const salesPitchSlice = createSlice({
    name: 'salesPitch',
    initialState: salesPitchInitialState,
    reducers: Object.assign({}, salesPitchReducers),
    extraReducers: builder => {
        SalesPitchExtraReducers(builder);
    },
});
export const Thunks = Object.assign({}, SalesPitchThunks);
export const { actions } = salesPitchSlice;
export default salesPitchSlice.reducer;
